/* eslint-disable react/no-array-index-key */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import { Link, useNavigate, useParams } from 'react-router-dom';
import {
  Button,
  Box,
  Grid,
  Card,
  CardContent,
  CardHeader,
  CardActions,
  TextField,
  Typography,
  Stack,
  MenuItem
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { ValidateBankDetails } from '../../assets/validation';
import SettingAction from '../../store/actions/SettingAction';
import globalAction from '../../store/actions/GlobalAction';
import Loader from '../../utils/errorPages/Loader';
import DecryptData from '../../utils/DecryptData';

function BankConfigurationView() {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [dataItem, setDataItem] = useState('');
  const { bankItemData, isLoading } = useSelector((state) => state.setting);
  const { statusData } = useSelector((state) => state.global);

  const { code } = useParams();

  useEffect(() => {
    dispatch(globalAction.getClientStatus());
    dispatch(SettingAction.getBankItem(code));
  }, [dispatch, code]);

  useEffect(() => {
    if (bankItemData && bankItemData !== undefined) {
      let decryptJson;
      setTimeout(() => {
        decryptJson = DecryptData(bankItemData);
        setDataItem(decryptJson);
      }, 500);
    }
  }, [bankItemData]);

  return (
    <Box sx={{ mb: 3 }} className="cardWrapper requestType">
      {isLoading ? <Loader /> : ''}
      <div className="pageTitleWrap">
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="text" component={Link} to="/settings/bank">
            Bank Configuration
          </Typography>
          <Typography component="h2" variant="h2">
            / View
          </Typography>
        </Stack>
      </div>
      <Formik
        initialValues={{
          gstin: dataItem?.gstin ?? '',
          import_export_code: dataItem?.import_export_code ?? '',
          satellite_station: dataItem?.satellite_station ?? '',
          destination: dataItem?.destination ?? '',
          phone: dataItem?.phone ?? '',
          email: dataItem?.email ?? '',
          beneficiary_bank_account: dataItem?.beneficiary_bank_account ?? '',
          beneficiary_bank_name: dataItem?.beneficiary_bank_name ?? '',
          bank_address: dataItem?.bank_address ?? '',
          bank_city: dataItem?.bank_city ?? '',
          bank_state: dataItem?.state?.name ?? '',
          bank_zip: dataItem?.bank_zip ?? '',
          bank_country: dataItem?.country?.name ?? '',
          bank_phone: dataItem?.bank_phone ?? '',
          ifsc: dataItem?.ifsc ?? '',
          bank_routing_shift: dataItem?.bank_routing_shift ?? '',
          note: dataItem?.note ?? '',
          tax_id: dataItem?.tax_id ?? '',
          status: dataItem?.status ?? ''
        }}
        validationSchema={ValidateBankDetails}
        enableReinitialize
        onSubmit={() => {}}
      >
        {({
          errors,
          touched,
          values,
          handleBlur,
          handleChange,
          handleSubmit,
          // isSubmitting,
          setFieldValue
        }) => (
          <form onSubmit={handleSubmit} autoComplete="off">
            <Grid container spacing={2}>
              <Grid item md={12} lg={12}>
                <Card sx={{ borderRadius: '0px' }}>
                  <CardHeader
                    title="Bank Details"
                    action={
                      <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        onClick={() => {
                          setShow(!show);
                        }}
                      >
                        {show ? 'Hide All Details' : 'Show All Details'}
                      </Button>
                    }
                  />
                  <CardContent>
                    <Grid container columnSpacing={2} rowSpacing={1}>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="addresses"
                          name="addresses"
                          label="Office Addresses"
                          variant="outlined"
                          disabled
                          value={(dataItem?.addresses ?? [])
                            .map((address) => address.address_type)
                            .join(', ')}
                          margin="normal"
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="beneficiary_bank_account"
                          name="beneficiary_bank_account"
                          label="Bank Account Number"
                          type={show ? 'text' : 'password'}
                          variant="outlined"
                          disabled
                          value={values.beneficiary_bank_account}
                          margin="normal"
                          inputProps={{
                            maxLength: 16
                          }}
                          onChange={handleChange}
                          onBlur={(e) => {
                            const val = (e.target.value || '').replace(/\s+/gi, '');
                            setFieldValue(e.target.name, val.trim());
                            handleBlur(e);
                          }}
                          error={
                            touched.beneficiary_bank_account &&
                            Boolean(errors.beneficiary_bank_account)
                          }
                          helperText={
                            touched.beneficiary_bank_account && errors.beneficiary_bank_account
                          }
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="beneficiary_bank_name"
                          name="beneficiary_bank_name"
                          label="Bank Name"
                          disabled
                          type={show ? 'text' : 'password'}
                          variant="outlined"
                          margin="normal"
                          onChange={handleChange}
                          value={values.beneficiary_bank_name}
                          onBlur={(e) => {
                            handleBlur(e);
                            const val = (e.target.value || '').replace(/\s+/gi, ' ');
                            setFieldValue(e.target.name, val.trim());
                          }}
                          error={
                            touched.beneficiary_bank_name && Boolean(errors.beneficiary_bank_name)
                          }
                          helperText={touched.beneficiary_bank_name && errors.beneficiary_bank_name}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="ifsc"
                          name="ifsc"
                          label="Bank IFSC Code"
                          type={show ? 'text' : 'password'}
                          variant="outlined"
                          disabled
                          margin="normal"
                          inputProps={{
                            maxLength: 11
                          }}
                          value={values.ifsc}
                          onChange={handleChange}
                          onBlur={(e) => {
                            handleBlur(e);
                            const val = (e.target.value || '').replace(/\s+/gi, '');
                            setFieldValue(e.target.name, val.trim());
                          }}
                          error={touched.ifsc && Boolean(errors.ifsc)}
                          helperText={touched.ifsc && errors.ifsc}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="bank_routing_shift"
                          name="bank_routing_shift"
                          disabled
                          type={show ? 'text' : 'password'}
                          label="Bank Routing Shift"
                          variant="outlined"
                          margin="normal"
                          inputProps={{
                            maxLength: 16
                          }}
                          value={values.bank_routing_shift}
                          onChange={handleChange}
                          onBlur={(e) => {
                            handleBlur(e);
                            const val = (e.target.value || '').replace(/\s+/gi, '');
                            setFieldValue(e.target.name, val.trim());
                          }}
                          error={touched.bank_routing_shift && Boolean(errors.bank_routing_shift)}
                          helperText={touched.bank_routing_shift && errors.bank_routing_shift}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="bank_phone"
                          name="bank_phone"
                          label="Bank Phone Number"
                          disabled
                          variant="outlined"
                          margin="normal"
                          value={values.bank_phone}
                          onChange={handleChange}
                          onBlur={(e) => {
                            handleBlur(e);
                            setFieldValue('bank_phone', values.bank_phone);
                          }}
                          error={touched.bank_phone && Boolean(errors.bank_phone)}
                          helperText={touched.bank_phone && errors.bank_phone}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="bank_address"
                          name="bank_address"
                          label="Bank Address"
                          variant="outlined"
                          disabled
                          margin="normal"
                          value={values.bank_address}
                          onChange={handleChange}
                          onBlur={(e) => {
                            handleBlur(e);
                            const val = (e.target.value || '').replace(/\s+/gi, ' ');
                            setFieldValue(e.target.name, val.trim());
                          }}
                          error={touched.bank_address && Boolean(errors.bank_address)}
                          helperText={touched.bank_address && errors.bank_address}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="bank_country"
                          name="bank_country"
                          label="Bank Country"
                          disabled
                          variant="outlined"
                          margin="normal"
                          value={values.bank_country}
                          onChange={handleChange}
                          onBlur={(e) => {
                            handleBlur(e);
                            const val = (e.target.value || '').replace(/\s+/gi, ' ');
                            setFieldValue(e.target.name, val.trim());
                          }}
                          error={touched.bank_country && Boolean(errors.bank_country)}
                          helperText={touched.bank_country && errors.bank_country}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="bank_state"
                          name="bank_state"
                          label="Bank State"
                          disabled
                          variant="outlined"
                          margin="normal"
                          value={values.bank_state}
                          onChange={handleChange}
                          onBlur={(e) => {
                            handleBlur(e);
                            const val = (e.target.value || '').replace(/\s+/gi, ' ');
                            setFieldValue(e.target.name, val.trim());
                          }}
                          error={touched.bank_state && Boolean(errors.bank_state)}
                          helperText={touched.bank_state && errors.bank_state}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="bank_city"
                          name="bank_city"
                          label="Bank City"
                          disabled
                          variant="outlined"
                          margin="normal"
                          value={values.bank_city}
                          onChange={handleChange}
                          onBlur={(e) => {
                            handleBlur(e);
                            const val = (e.target.value || '').replace(/\s+/gi, ' ');
                            setFieldValue(e.target.name, val.trim());
                          }}
                          error={touched.bank_city && Boolean(errors.bank_city)}
                          helperText={touched.bank_city && errors.bank_city}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="bank_zip"
                          name="bank_zip"
                          label="Bank ZIP Number"
                          disabled
                          variant="outlined"
                          margin="normal"
                          value={values.bank_zip}
                          onChange={handleChange}
                          onBlur={(e) => {
                            handleBlur(e);
                            const val = (e.target.value || '').replace(/\s+/gi, '');
                            setFieldValue(e.target.name, val.trim());
                          }}
                          error={touched.bank_zip && Boolean(errors.bank_zip)}
                          helperText={touched.bank_zip && errors.bank_zip}
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
                <Card sx={{ borderRadius: '0px', mt: 2 }}>
                  <CardHeader title="Organisation Details" />
                  <CardContent>
                    <Grid container columnSpacing={2} rowSpacing={1}>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="email"
                          type="email"
                          name="email"
                          label="Email"
                          disabled
                          variant="outlined"
                          margin="normal"
                          value={values.email}
                          onChange={handleChange}
                          onBlur={(e) => {
                            handleBlur(e);
                            const val = (e.target.value || '').replace(/\s+/gi, '');
                            setFieldValue(e.target.name, val.trim());
                          }}
                          error={touched.email && Boolean(errors.email)}
                          helperText={touched.email && errors.email}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="phone"
                          name="phone"
                          label="Phone Number"
                          disabled
                          variant="outlined"
                          margin="normal"
                          value={values.phone}
                          onChange={handleChange}
                          onBlur={(e) => {
                            handleBlur(e);
                            const val = (e.target.value || '').replace(/\s+/gi, '');
                            setFieldValue(e.target.name, val.trim());
                          }}
                          error={touched.phone && Boolean(errors.phone)}
                          helperText={touched.phone && errors.phone}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="gstin"
                          name="gstin"
                          type={show ? 'text' : 'password'}
                          label="GSTIN"
                          disabled
                          inputProps={{
                            maxLength: 15
                          }}
                          variant="outlined"
                          margin="normal"
                          value={values.gstin}
                          onChange={handleChange}
                          onBlur={(e) => {
                            handleBlur(e);
                            const val = (e.target.value || '').replace(/\s+/gi, '');
                            setFieldValue(e.target.name, val.trim());
                          }}
                          error={touched.gstin && Boolean(errors.gstin)}
                          helperText={touched.gstin && errors.gstin}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="import_export_code"
                          name="import_export_code"
                          type={show ? 'text' : 'password'}
                          label="Import-Export Code"
                          disabled
                          variant="outlined"
                          inputProps={{
                            maxLength: 10
                          }}
                          margin="normal"
                          value={values.import_export_code}
                          onChange={handleChange}
                          onBlur={(e) => {
                            handleBlur(e);
                            const val = (e.target.value || '').replace(/\s+/gi, '');
                            setFieldValue(e.target.name, val.trim());
                          }}
                          error={touched.import_export_code && Boolean(errors.import_export_code)}
                          helperText={touched.import_export_code && errors.import_export_code}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="satellite_station"
                          name="satellite_station"
                          label="Satellite Station"
                          disabled
                          variant="outlined"
                          margin="normal"
                          inputProps={{
                            maxLength: 32
                          }}
                          value={values.satellite_station}
                          onChange={handleChange}
                          onBlur={(e) => {
                            handleBlur(e);
                            const val = (e.target.value || '').replace(/\s+/gi, ' ');
                            setFieldValue(e.target.name, val.trim());
                          }}
                          error={touched.satellite_station && Boolean(errors.satellite_station)}
                          helperText={touched.satellite_station && errors.satellite_station}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="destination"
                          name="destination"
                          label="Destination"
                          disabled
                          variant="outlined"
                          margin="normal"
                          inputProps={{
                            maxLength: 32
                          }}
                          value={values.destination}
                          onChange={handleChange}
                          onBlur={(e) => {
                            handleBlur(e);
                            const val = (e.target.value || '').replace(/\s+/gi, ' ');
                            setFieldValue(e.target.name, val.trim());
                          }}
                          error={touched.destination && Boolean(errors.destination)}
                          helperText={touched.destination && errors.destination}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="tax_id"
                          name="tax_id"
                          label="Tax ID"
                          type={show ? 'text' : 'password'}
                          variant="outlined"
                          disabled
                          margin="normal"
                          value={values.tax_id}
                          inputProps={{
                            maxLength: 11
                          }}
                          onChange={handleChange}
                          onBlur={(e) => {
                            const val = (e.target.value || '').replace(/\s+/gi, '');
                            setFieldValue(e.target.name, val.trim());
                          }}
                          error={touched.tax_id && Boolean(errors.tax_id)}
                          helperText={touched.tax_id && errors.tax_id}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          id="status"
                          fullWidth
                          label="Status"
                          name="status"
                          disabled
                          margin="normal"
                          select
                          value={values.status}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors.status && touched.status}
                          helperText={errors.status && touched.status && errors.status}
                        >
                          {statusData &&
                            statusData.map((option) => (
                              <MenuItem key={option.id} value={option.id}>
                                {option.status}
                              </MenuItem>
                            ))}
                        </TextField>
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="note"
                          name="note"
                          label="Note"
                          disabled
                          multiline
                          maxRows={3}
                          variant="outlined"
                          margin="normal"
                          inputProps={{
                            maxLength: 128
                          }}
                          value={values.note}
                          onChange={handleChange}
                          onBlur={(e) => {
                            handleBlur(e);
                            const val = (e.target.value || '').replace(/\s+/gi, ' ');
                            setFieldValue(e.target.name, val.trim());
                          }}
                          error={touched.note && Boolean(errors.note)}
                          helperText={touched.note && errors.note}
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item lg={12} xl={12}>
                <Card sx={{ borderRadius: '0px' }}>
                  <CardActions sx={{ justifyContent: 'center', p: 3 }}>
                    <Button
                      type="button"
                      className="cancel__btn"
                      variant="contained"
                      // fullWidth
                      color="primary"
                      size="medium"
                      onClick={() => {
                        navigate('/settings/bank');
                      }}
                    >
                      Back
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </Box>
  );
}
export default BankConfigurationView;
